import { matchPath, useLocation } from 'react-router-dom'

export function ComponentGuard({
	children,
	includeRoutes,
	excludeRoutes,
}: {
	children: JSX.Element
	includeRoutes?: any[]
	excludeRoutes?: any[]
}) {
	const { pathname } = useLocation()
	let isValid = true // Default to true if no conditions are provided

	// Check includeRoutes condition
	if (includeRoutes) {
		isValid = isValid && !!includeRoutes.find(route => matchPath(route, pathname))
	}

	// Check excludeRoutes condition
	if (excludeRoutes) {
		isValid = isValid && !excludeRoutes.find(route => matchPath(route, pathname))
	}

	return isValid ? children : null
}

export function useAllowComponent({ includeRoutes, excludeRoutes }: { includeRoutes?: any[]; excludeRoutes?: any[] }) {
	const { pathname } = useLocation()
	let isValid = true // Default to true if no conditions are provided

	// Check includeRoutes condition
	if (includeRoutes) {
		isValid = isValid && !!includeRoutes.find(route => matchPath(route, pathname))
	}

	// Check excludeRoutes condition
	if (excludeRoutes) {
		isValid = isValid && !excludeRoutes.find(route => matchPath(route, pathname))
	}

	return isValid
}
